module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NNuBMp/media/FC-9798886939705.jpg?1697494195242",
      "alt": "This image is the cover for the book Nanny’s Dimes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nanny’s Dimes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Josephine was born on February 7th, 1917, in the small village of Little River Harbor, Nova Scotia. Her childhood was spent on the family farm with her five other siblings. There was little money but lots of food and lots of love.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Her life was not always full of happiness. She faced many difficult and sad times, found love and lost love, was gravely ill, and through her faith, she was healed. Josephine was determined to overcome anything that came her way.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("She selflessly raised two generations, giving it her all each time. She loved it when the grand, great-grand, and great-great-grandchildren came to visit.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Her faith was very strong. She spent her lifetime attending mass and helping others in need. Her patron saint was the Virgin Mary. So many times, she prayed for her help and always received it. Through God")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("’")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("s grace, she was healed from a serious illness that left her learning to walk again. She was never discouraged and always said that pain was something everyone had to go through to go to heaven.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("The dimes that she sent after is a good indication that she indeed made it there.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lesley D. Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "14.25pt",
      "margin-left": "28.55pt",
      "font-size": "20px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "margin": "0mm",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "windowtext"
    }
  }, [_vm._v("At the tip of Nova Scotia, in a town of Yarmouth, Lesley D. Scott was raised by her grandparents from birth. Always being around the elder members of the family, she heard many stories about her grandmother’s childhood and life as a young woman. In her grandmother’s last years, she decided to write things down while her grandmother was there to answer any questions. This family history would be preserved for future generations.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0